import app from 'flarum/common/app';

app.initializers.add('xypp/flarum-invite-user', () => {
  console.log('[xypp/flarum-invite-user] Hello, forum and admin!');
});
